import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import jwtDecode from 'jwt-decode';
import { Typography, Button } from '@mui/material';
import { Box } from '@mui/system';
import { useAuth } from '../../services/contexts/AuthContext';
import DownloadStandardBills from './DownloadStandardBills';
import DownloadErpDataBills from './DownloadErpDataBills';
import DownloadChargingHistory from './DownloadChargingHistory';
import { useTranslation } from 'react-i18next';
import LogoLoader from '../../components/LogoLoader';
import { useTokenUtils } from '../../services/utils/tokenUtils';
import api from '../../Middleware/api/api';

function DownloadCenter() {
  const { t, i18n } = useTranslation();

  const { token } = useAuth();
  const decodedToken = token ? jwtDecode(token) : null;
  const { isAdminRole } = useTokenUtils();
  const [displayPage, setDisplayPage] = useState('CSV');
  const [loading, setLoading] = useState(false);
  const [stations, setStations] = useState([]);
  const [operators, setOperators] = useState([]);

  const getDistinctCPOsAndCpoName = (response) => {
    const distinctCPOs = response?.reduce((acc, current) => {
      const x = acc.find((item) => item.cpoId === current.cpoId);
      if (!x) {
        acc.push({ cpoId: current.cpoId, cpoName: current.cpoName });
      }
      return acc;
    }, []);

    return distinctCPOs;
  };

  const getStations = async () => {
    setLoading(true);
    api.fetchLocationsForDropDown(token).then((response) => {
      if (response?.data?.data == null) {
        setStations([]);
      } else {
        setStations(response?.data?.data);
        setOperators(getDistinctCPOsAndCpoName(response?.data?.data));
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    getStations();
    return () => {
      setStations([]);
    };
  }, []);

  const handleClick = (component) => {
    setDisplayPage(component);
  };

  return (
    <React.Fragment>
      <LogoLoader loading={loading} />
      <Helmet title="Blank" />
      <Typography variant="h3" gutterBottom display="inline">
        Download Center
      </Typography>
      <div style={{ margin: '10px' }}>
        <Button
          style={{ width: '140px', height: '35px', margin: '2px' }}
          variant="contained"
          color={displayPage === 'CSV' ? 'primary' : 'inherit'}
          onClick={() => handleClick('CSV')}
        >
          {t('LBLLoadingHostory')}
        </Button>
        <Button
          style={{
            width: '150px',
            height: '35px',
            margin: '2px',
            display:
              decodedToken?.customer_type === 'Partner' ||
              decodedToken?.customer_type === 'Operator' ||
              isAdminRole
                ? true
                : 'none',
          }}
          variant="contained"
          color={displayPage === 'BillingCSV' ? 'primary' : 'inherit'}
          onClick={() => handleClick('BillingCSV')}
        >
          {t('LBLRechnungen')}
        </Button>

        <Button
          style={{
            width: '150px',
            height: '35px',
            margin: '2px',
            display:
              decodedToken?.customer_type === 'Partner' || isAdminRole
                ? true
                : 'none',
          }}
          variant="contained"
          color={displayPage === 'XML' ? 'primary' : 'inherit'}
          onClick={() => handleClick('XML')}
        >
          {t('LBLERPImport')}
        </Button>
      </div>
      <Box
        width="100%"
        sx={{
          position: 'absolute',
          left: 0,
          bottom: '5%',

          '@media (orientation: landscape)': {
            position: 'inherit',
            left: 'unset',
            bottom: 'unset',
          },
        }}
      >
        {displayPage === 'CSV' && (
          <DownloadChargingHistory stations={stations} operators={operators} />
        )}
        {displayPage === 'BillingCSV' && (
          <DownloadStandardBills stations={stations} operators={operators} />
        )}
        {displayPage === 'XML' && (
          <DownloadErpDataBills stations={stations} operators={operators} />
        )}
      </Box>
    </React.Fragment>
  );
}

export default DownloadCenter;
